import React from 'react'
import Loading from './Loading'

interface Props {
  status?: string
}

const StatusPopup = (props: Props) => {
  return (
    <div className='opacity-50 flex items-center fixed z-30 p-2 px-4 left-1/2 -translate-x-1/2 bottom-16 rounded-full text-sm bg-black text-white'>
      {props.status}
      <Loading size={4} padding={4} />
    </div>
  )
}

export default StatusPopup